export default __webpack_public_path__ + "static/media/discover.a437c8d5.jpeg";